import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import useDataFetcher from '../../../knisot/hooks/useFetchData'
import { Defaults } from '../../../../../../modules/API/Defaults/defaults'
import { Pallets } from '../../../../../../modules/API/Pallets/pallets'
import { ICoolingSiteItem } from '../../../../../../modules/API/Defaults/models/coolingSites'
import { LOAD, LOAD_END } from '../../../../../../../store/actions/actionsTypes'
import { handleNotifications } from '../../../../../../generic/utils/handleNotifications'
import usePalletLookup from '../../shared/hooks/usePalletLookup'
import { buildCoolingPayload } from '../../shared/helpers/palletPayloads'

/** Business logic for the pallet/cooling screen: find a pallet, pick a cooling site, update it. */
const useCoolingSite = () => {
  const dispatch = useDispatch()
  const lookup = usePalletLookup()
  const { data: coolingSites } = useDataFetcher<ICoolingSiteItem[]>(Defaults.getCoolingSites, 'data')
  const [selectedSite, setSelectedSite] = useState<ICoolingSiteItem | null>(null)

  const submit = useCallback(async () => {
    if (!lookup.palletFound || !selectedSite) return
    dispatch({ type: LOAD })
    try {
      await Pallets.putPalletCoolingSite(lookup.palletFound.Pallet_Num, buildCoolingPayload(selectedSite))
      handleNotifications('קירור עודכן בהצלחה', { type: 'success' })
      setSelectedSite(null)
      lookup.reset()
    } catch (error) {
      handleNotifications('משהו השתבש', { type: 'error' })
    } finally {
      dispatch({ type: LOAD_END })
    }
  }, [lookup, selectedSite, dispatch])

  return {
    ...lookup,
    coolingSites: coolingSites ?? [],
    selectedSite,
    setSelectedSite,
    submit,
    canSubmit: !!lookup.palletFound && !!selectedSite,
  }
}

export default useCoolingSite
